import { getSuperStoreInstance } from './getSuperStoreInstance';
export const setSuperStoreValue = (key, value) => getSuperStoreInstance().then(store => store && store.set(key, value));